import { AuthenticatedUser } from '../authentication';
import { DateObject } from '../reusables/date-object';
import { Icon } from '../reusables/icon';
import { Customer } from './customer';

/**
 * Blueprint for the activity history / contact management.
 */
export class Contact {
  public createdAt: DateObject;
  public updatedAt: DateObject;
  public id: number;
  public title: string;
  public comment: string;
  public user: AuthenticatedUser;
  public customer: Customer;
  public important: boolean;

  public pinned: Icon | string;

  public constructor(contactManagement?: any) {
    this.id = contactManagement.id;
    this.title = contactManagement.title;
    this.comment = contactManagement.comment;
    this.createdAt = new DateObject(contactManagement.createdAt, 'dd.MM.yyyy HH:mm');
    this.updatedAt = new DateObject(contactManagement.updatedAt, 'dd.MM.yyyy HH:mm');
    this.user = contactManagement.user;
    this.customer = contactManagement.contact;
    this.important = contactManagement.important;
    this.pinned = this.important ? new Icon('#esf-icon-pin', '') : '';
  }

  get fullName(): string {
    return `${this.user.firstName} ${this.user.lastName}`;
  }
}
